import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-16 md:py-20 bg-black" data-id="element-81">
      <div className="container mx-auto px-4" data-id="element-82">
        <div className="max-w-3xl mx-auto bg-white/[0.02] border border-white/10 rounded-2xl p-8 md:p-12 text-center" data-id="element-83">
          <img src="https://cdn-icons-png.flaticon.com/512/9370/9370213.png" alt="Garantía de 72hs" className="w-16 h-16 md:w-20 md:h-20 mx-auto mb-6 opacity-90" data-id="element-84" />
          <p className="text-purple-400 font-bold uppercase tracking-wider text-sm mb-2" data-id="element-85">
            Cero riesgo para vos
          </p>
          <h2 className="text-2xl md:text-3xl font-bold mb-4" data-id="element-86">
            Garantía Total de 72hs
          </h2>
          <p className="text-gray-400 leading-relaxed text-base md:text-lg mb-8" data-id="element-87">
            Probá Techain durante 72 horas. Si no te convence, escribinos y te
            devolvemos el 100% de tu dinero. Sin preguntas, sin excusas, sin
            letra chica. Así de seguros estamos de que te va a servir.
          </p>

          <div className="flex flex-wrap justify-center gap-4 text-xs md:text-sm text-gray-500 font-medium" data-id="element-88">
            <span className="flex items-center gap-1" data-id="element-89">
              🔒 Reembolso garantizado
            </span>
            <span className="hidden md:inline" data-id="element-90">·</span>
            <span className="flex items-center gap-1" data-id="element-91">
              📧 Soporte por email
            </span>
            <span className="hidden md:inline" data-id="element-92">·</span>
            <span className="flex items-center gap-1" data-id="element-93">⚡ Proceso en 24hs</span>
          </div>
        </div>
      </div>
    </section>;
}